import { ITradeComment } from '@shared/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getState = createFeatureSelector<State>('feed');

export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getFeed = createSelector(
  getState,
  (state: State) => state.data
);

export const getFeedGroupedByDate = createSelector(
  getFeed,
  (feed: ITradeComment[]) => {
    const tradeFeedByGroupedByDate = feed
      .reduce((map, comment) => {
        const date = new Date(comment.createdDate);
        const dateIdentifier = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

        if (!map.has(dateIdentifier)) {
          map.set(dateIdentifier, []);
        }

        map.get(dateIdentifier).push(comment);

        return map;
      }, new Map());

    return tradeFeedByGroupedByDate;
  }
);

